var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeeper1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1440px",
    height: "529px",
    viewBox: "0 0 1440 529",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy",
    transform: "translate(0.000000, -2198.000000)",
    fill: "#72AEC4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "innovative..",
    transform: "translate(0.000000, 772.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,1441.52014 C204.791053,1468.98392 346.710243,1484.93541 425.757568,1489.37463 C544.328557,1496.03346 576.555107,1489.47625 686.176025,1480.05511 C795.796944,1470.63398 762.89455,1444.10891 946.278809,1441.52014 C1129.66307,1438.93136 1156.47176,1476.80869 1274.94531,1471.74365 C1353.92768,1468.36696 1408.87374,1453.3044 1439.78349,1426.55597 L1439.78349,1954.48865 L0,1954.48865",
    id: "Path-4"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeeper1);
export default __webpack_public_path__ + "static/media/deeper1.fd17f7b9a1ed80736cfa426e80247876.svg";
export { ForwardRef as ReactComponent };